import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './common/Header';
import Nav from './common/Navigation';
import MessageFeed from './common/MessageFeed';

export default function Message({titleHead}){
	
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/Message')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
			<Header titleHead={titleHead}/>
			<main>
				<h2>Hey Engage</h2> 
				<h5>Conversations make new friends go out and conquer your fears, I know its scary but Take your leap</h5>
				<hr />
				<MessageFeed />
				<MessageFeed />
				
			</main>
			<Nav />
		</>
	);
}